'use strict';

/*global isEmpty*/

/*exported resClose */
var resClose = 1;

/*exported resSuccess */
var resSuccess = 2;

/*exported resError */
var resError = 3;

/*exported weightNetto */
var weightNetto = 1;

/*exported weightBrutto */
var weightBrutto = 2;

/*exported normalizeInput */
function normalizeInput(data) {
  if (isEmpty(data)) {
    data = {
      content: '',
      title: ''
    };
  }

  if (typeof data === 'string') {
    var str = data;

    data = {};
    data.content = str;
    data.title = '';
  }

  if (!('title' in data)) {
    data.title = '';
  }

  if (!('content' in data)) {
    data.content = '';
  }

  return data;
}

/*exported getItemById */
function getItemById(listOfItems, id) {
  if (!Number.isInteger(id)) {
    id = parseInt(id, 10);
  }

  for (var i = 0; i < listOfItems.length; i++) {
    var item = listOfItems[i];

    if (item.id === id) {
      return item;
    }
  }

  return null;
}
